import { render, staticRenderFns } from "./DualToggle.vue?vue&type=template&id=08ac02ca&"
import script from "./DualToggle.vue?vue&type=script&lang=ts&"
export * from "./DualToggle.vue?vue&type=script&lang=ts&"
import style0 from "./DualToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports